import { CreateDrawer } from "../../components/drawer/DrawerComponent";
import { sAddCategory } from "../../constants/strings";
import { CategoryForm } from "../../forms/CategoryForm";
import { CategoriesRegister } from "./CategoriesRegister";

export const Categories = () => {
  return (
    <div>
      <CreateDrawer title={sAddCategory} form={<CategoryForm />} />
      <CategoriesRegister />
    </div>
  );
};
